import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';

const createLazyImage = importFunc => {
   const LazyComponent = lazy(importFunc);

   const LazySVGWrapper = function LazySVGWrapper(props) {
      return React.createElement(
         Suspense,
         {
            fallback: React.createElement('div', {
               className: 'skeleton-box',
               style: {
                  width: props.width || '100%',
                  height: props.height || '100%',
                  backgroundColor: 'var(--gray-200)',
                  borderRadius: '8px',
                  animation: 'skeleton-pulse 1.5s infinite',
               },
            }),
         },
         React.createElement(LazyComponent, props),
      );
   };

   LazySVGWrapper.propTypes = {
      width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   };

   return LazySVGWrapper;
};

// ============================================
// GENERAL UI ICONS & IMAGES
// ============================================
export { default as SidenavLogo } from 'assets/images/sidenav-logo.svg?react';
export { default as loginlogo } from 'assets/images/mirrorfly-teams.svg?react';
export { default as loginlogoDark } from 'assets/images/mirrorfly-teams-dark.svg';
export { default as DotsLight } from 'assets/images/dots-light.svg?react';
export { default as DotsDark } from 'assets/images/dots-dark.svg?react';
export { default as MirrorflyteamWhite } from 'assets/images/mirrorfly-teams-white.svg?react';
export { default as VideoVoiceCalling } from 'assets/images/video-and-voice-calling.svg?react';
export { default as SecurityScalability } from 'assets/images/security-and-scalability.svg?react';
export { default as LightningFastMessage } from 'assets/images/Lightning-fast-message.svg?react';
export { default as mirrorflyteam } from 'assets/images/mirrorfly-teams.svg?react';
export { default as Call } from 'assets/images/white-call.svg?react';
export { default as ChannelAnnouncement } from 'assets/images/ChannelAnnouncement.png';
export { default as Close } from 'assets/images/search_close.svg?react';
export { default as DefaultProfilePicture } from 'assets/images/DefaultProfilePicture.jpg';
export { default as ExitGroup } from 'assets/images/exitgroup.svg?react';
export { default as ImageCreateChannel } from 'assets/images/ImageCreateChannel.png';
export { default as ImgUserPlaceholder } from 'assets/images/user-placeholder.svg?react';
export { default as Info } from 'assets/images/errorinfo.svg?react';
export { default as Loader } from 'assets/images/loader.svg?react';
export { default as Lockloader } from 'assets/images/lock_new.svg?react';
export { default as NewLogoVector } from 'assets/images/logo.svg?react';
export { default as Placeholder } from 'assets/images/media-types/placeholder.svg';
export { default as PreviewNext } from './preview_next.svg?react';
export { default as PreviewPrev } from './preview_prev.svg?react';
export { default as play } from 'assets/images/new-img/play.svg?react';
export { default as pause } from 'assets/images/new-img/pause.svg?react';
export { default as Reset } from 'assets/images/reset.svg?react';
export { default as Retake } from 'assets/images/retake.svg?react';
export { default as SandTimerIcon } from 'assets/images/sand-timer.svg?react';
export { default as ScanQRLogo } from 'assets/images/scan-code-middle.png';
export { default as SendMessage } from 'assets/images/sendMessage.svg?react';
export { default as Tick } from 'assets/images/tick.svg?react';
export { default as VideoOff } from 'assets/images/video-off.svg?react';
export { default as VideoOn } from 'assets/images/video-on.svg?react';
export { default as ZoomIn } from './zoom-in.svg?react';
export { default as ZoomOut } from './zoom-out.svg?react';
export { default as ZoomRestore } from './zoom-restore.svg?react';
export { default as callWelcomeUrl } from './call_welcome.svg';
export { default as meetWelcomeUrl } from './meet_welcome.svg';
export { default as MicChromeGif } from './mic_chrome_permission.gif';
export { default as MicEdgeGif } from './mic_edge_permission.gif';
export { default as MicFirefoxGif } from './mic_firefox_permission.gif';
export { default as MicSafariGif } from './mic_safari_permission.gif';
export { default as ViewPhoto } from './new-img/view-photo.svg?react';
export { default as VideoChromeGif } from './video_chrome_permission.gif';
export { default as VideoEdgeGif } from './video_edge_permission.gif';
export { default as VideoFirefoxGif } from './video_firefox_permission.gif';
export { default as VideoSafariGif } from './video_safari_permission.gif';

// ============================================
// ICON COMPONENTS
// ============================================
export { default as IconAlert } from 'assets/images/IconAlert.svg?react';
export { default as IconArrowDown } from 'assets/images/channelarrowdown.svg?react';
export { default as IconArrowright } from 'assets/images/arrowright.svg?react';
export { default as IconBlock } from 'assets/images/IconBlock.svg?react';
export { default as IconCalendar } from 'assets/images/IconCalendar.svg?react';
export { default as IconEmptyArchive } from 'assets/images/emptyArchive.svg?react';
export { default as IconLock } from 'assets/images/IconLock.svg?react';
export { default as IconLogout } from 'assets/images/IconLogout.svg?react';
export { default as IconTrash } from 'assets/images/IconTrash.svg?react';
export { default as IconUserPlus } from 'assets/images/IconUserPlus.svg?react';
export { default as IconWorld } from 'assets/images/IconWorld.svg?react';

// ============================================
// AUDIO & MEDIA (A-Z)
// ============================================
export { default as AudioFile } from './audio-file.svg?react';
export { default as AudioIcon } from './audio-file.svg?react';
export { default as AudioRecord } from 'assets/images/audio-record.png';
export { default as AudioRecorder } from './recorder.svg?react';

// ============================================
// FILE TYPE ICONS (A-Z)
// ============================================
export { default as Csv } from 'assets/images/media-types/csv.svg?react';
export { default as Excel } from 'assets/images/media-types/excel.svg?react';
export { default as Pdf } from 'assets/images/media-types/pdf.svg?react';
export { default as Ppt } from 'assets/images/media-types/ppt.svg?react';
export { default as Rar } from 'assets/images/media-types/rar.svg?react';
export { default as Txt } from 'assets/images/media-types/txt.svg?react';
export { default as Word } from 'assets/images/media-types/word.svg?react';
export { default as Zip } from 'assets/images/media-types/Zip.svg?react';

// ============================================
// ATTACHMENTS
// ============================================
export { default as Attachment } from 'assets/images/attachments.svg?react';

// Media Preview Icons
export { default as PreviewForward } from './preview_forward.svg?react';
export { default as PreviewStar } from './preview_star.svg?react';
export { default as PreviewStarActive } from './preview_star_active.svg?react';

// new-img code start here ****************/
export { default as ArrowBendUpLeftIcon } from 'assets/images/new-img/arrowbend-upleft-icon.svg?react';
export { default as ArrowLeftIcon } from 'assets/images/new-img/arrowleft-icon.svg?react';
export { default as AttachmentIcon } from 'assets/images/new-img/attachment-icon.svg?react';
export { default as AudiocallIcon } from 'assets/images/new-img/audiocall-icon.svg?react';
export const AvatarIcon = createLazyImage(() => import('assets/images/new-img/avatar-icon.svg?react'));
export { default as BellSimpleSlashIcon } from 'assets/images/new-img/bellsimpleslash-icon.svg?react';
export { default as CalendarSelectIcon } from 'assets/images/new-img/calender-select-icon.svg?react';
export { default as CalendarUnselectIcon } from 'assets/images/new-img/calender-unselect-icon.svg?react';
export { default as CallSelectIcon } from 'assets/images/new-img/call-select-icon.svg?react';
export { default as CallUnselectIcon } from 'assets/images/new-img/call-unselect-icon.svg?react';
export { default as CameraIcon } from 'assets/images/new-img/camera-icon.svg?react';
export { default as ChatIcon } from 'assets/images/new-img/chat-icon.svg?react';
export { default as ChatCenteredDotsIcon } from 'assets/images/new-img/chatcentereddots-icon.svg?react';
export { default as ChatSelectIcon } from 'assets/images/new-img/chat-select-icon.svg?react';
export { default as ChatUnselectIcon } from 'assets/images/new-img/chat-unselect-icon.svg?react';
export { default as CloseIcon } from 'assets/images/new-img/close-icon.svg?react';
export { default as ContactIcon } from 'assets/images/new-img/contact-icon.svg?react';
export { default as CopyIcon } from 'assets/images/new-img/copy-icon.svg?react';
export { default as DocumentIcon } from 'assets/images/new-img/document-icon.svg?react';
export { default as DotsThreeVerticalIcon } from 'assets/images/new-img/dots-three-vertical-icon.svg?react';
export { default as DropdownIcon } from 'assets/images/new-img/dropdown-icon.svg?react';
export { default as FaceSmileIcon } from 'assets/images/new-img/face-smile-icon.svg?react';
export { default as GroupAvatarIcon } from 'assets/images/new-img/group-avatar-icon.svg?react';
export { default as InfoIconNew } from 'assets/images/new-img/info-icon.svg?react';
export { default as LinkIcon } from 'assets/images/new-img/link-icon.svg?react';
export { default as LinkIconOne } from 'assets/images/new-img/link-icon-one.svg?react';
export { default as LocationIcon } from 'assets/images/new-img/location-icon.svg?react';
export { default as MessageChatIcon } from 'assets/images/new-img/message-chat-icon.svg?react';
export { default as EmailOutlineIcon } from 'assets/images/new-img/email-outline-icon.svg?react';
export { default as GmailLogoIcon } from 'assets/images/new-img/gmail-logo-icon.svg?react';
export { default as WhatsappLogoIcon } from 'assets/images/new-img/whatsapp-logo-icon.svg?react';
export { default as XLogoIcon } from 'assets/images/new-img/x-logo-icon.svg?react';
export { default as MicrophoneIcon } from 'assets/images/new-img/microphone-icon.svg?react';
export { default as MuteIcon } from 'assets/images/new-img/mute-icon.svg?react';
export { default as PinIcon } from 'assets/images/new-img/pin-icon.svg?react';
export { default as SearchIcon } from 'assets/images/new-img/search-icon.svg?react';
export { default as SettingSelectIcon } from 'assets/images/new-img/setting-select-icon.svg?react';
export { default as SettingUnselectIcon } from 'assets/images/new-img/setting-unselect-icon.svg?react';
export { default as StarIcon } from 'assets/images/new-img/star-icon.svg?react';
export { default as UnStarIcon } from 'assets/images/new-img/unstar-icon.svg?react';
export { default as TrashIcon } from 'assets/images/new-img/trash-icon.svg?react';
export { default as UserPlusIcon } from 'assets/images/new-img/user-plus-icon.svg?react';
export { default as VideocallIcon } from 'assets/images/new-img/videocall-icon.svg?react';
export { default as CreateNewGroupIcon } from 'assets/images/new-img/createnewgroup-icon.svg?react';
export { default as CreateNewChannelBgIcon } from 'assets/images/new-img/createnew-channel-bg-icon.svg?react';
export { default as InviteNewIcon } from 'assets/images/new-img/invitenew-icon.svg?react';
export const ChatEmptyState = createLazyImage(() => import('assets/images/new-img/chatemptystate.svg?react'));
export { default as DownloadIcon } from 'assets/images/new-img/download-icon.svg?react';
export { default as ImgIcon } from 'assets/images/new-img/img-icon.svg?react';
export { default as IconReload } from 'assets/images/new-img/IconReload.svg?react';
export { default as IconCreateGroup } from 'assets/images/new-img/IconCreateGroup.svg?react';
export { default as IconIncomingCallIcon } from 'assets/images/new-img/IconIncomingCallIcon.svg?react';
export { default as IconDeclineCallIcon } from 'assets/images/new-img/IconDeclineCallIcon.svg?react';

// Auth & Social Icons
export { default as MicrosoftIcon } from 'assets/images/new-img/microsoft-icon.svg?react';
export { default as GoogleLogoIcon } from 'assets/images/new-img/googlelogo-icon.svg?react';

// Channel & Chat Icons
//export { default as ChatIconNew } from 'assets/images/new-img/chat-icon.svg?react';

// Edit & Upload Icons
export { default as PencilSimpleLineIcon } from 'assets/images/new-img/pencilsimpleline-icon.svg?react';
export { default as UploadIcon } from 'assets/images/new-img/upload-icon.svg?react';
export { default as CameraIconNew } from 'assets/images/new-img/camera-icon.svg?react';
export { default as MoonIcon } from 'assets/images/new-img/moon-icon.svg?react';

// Action Icons
export { default as ProhibitIcon } from 'assets/images/new-img/prohibit-icon.svg?react';
export { default as MinusCircleIcon } from 'assets/images/new-img/minuscircle-icon.svg?react';
export { default as ThumbsDownIcon } from 'assets/images/new-img/thumbs-down-icon.svg?react';
export { default as SignOutIcon } from 'assets/images/new-img/signout-icon.svg?react';

// Document Icons
export { default as XlxsIcon } from 'assets/images/new-img/xlxs-icon.svg?react';
export { default as ZipIcon } from 'assets/images/new-img/zip-icon.svg?react';
export { default as TextIcon } from 'assets/images/new-img/text-icon.svg?react';
export { default as PptxIcon } from 'assets/images/new-img/pptx-icon.svg?react';
export { default as RarIcon } from 'assets/images/new-img/rar-icon.svg?react';
export { default as PptIcon } from 'assets/images/new-img/ppt-icon.svg?react';
export { default as PdfIcon } from 'assets/images/new-img/pdf-icon.svg?react';
export { default as ExcelIcon } from 'assets/images/new-img/excel-icon.svg?react';
export { default as DocxIcon } from 'assets/images/new-img/docx-icon.svg?react';
export { default as DocIcon } from 'assets/images/new-img/doc-icon.svg?react';
export { default as CsvIcon } from 'assets/images/new-img/csv-icon.svg?react';

// Call Icons
export { default as CallIcon } from 'assets/images/IconPhoneCall.svg?react';
export { default as VideoIcon } from 'assets/images/IconVideoCall.svg?react';
export { default as MissedCallIcon } from 'assets/images/IconMissedCall.svg?react';
export { default as OutgoingCallIcon } from 'assets/images/IconOutgoinCall.svg?react';
export { default as IconWhiteClose } from 'assets/images/IconWhiteClose.svg?react';
export { default as IconWhitePlus } from 'assets/images/IconWhitePlus.svg?react';
export { default as IconGrayVideo } from 'assets/images/IconGrayVideo.svg?react';
export { default as IconGrayPhone } from 'assets/images/IconGrayPhone.svg?react';
export { default as IconEmptyplaceholderCall } from 'assets/images/IconEmptyplaceholderCall.svg?react';
export { default as IconAudioMute } from 'assets/images/new-img/IconAudioMute.svg?react';
export { default as IconVideoMute } from 'assets/images/new-img/IconVideoMute.svg?react';
export { default as IconMic } from 'assets/images/new-img/IconMic.svg?react';
export { default as IconVideo } from 'assets/images/new-img/IconVideo.svg?react';
export { default as IconMediAudio } from 'assets/images/new-img/IconMediAudio.svg?react';
export { default as IncomingGroupCall } from 'assets/images/new-img/IncomingGroupCall.svg?react';
export { default as IconPoorNetwork } from 'assets/images/new-img/IconPoorNetwork.svg?react';
export { default as IconMuteGroup } from 'assets/images/new-img/IconMuteGroup.svg?react';
export { default as IconNotifications } from 'assets/images/new-img/IconNotifications.svg?react';
export { default as IconBoxArrowDown } from 'assets/images/new-img/IconBoxArrowDown.svg?react';
export { default as IconSend } from 'assets/images/new-img/IconSend.svg?react';
export { default as IconPlus } from 'assets/images/new-img/IconPlus.svg?react';
export const IconSchedule = createLazyImage(() => import('assets/images/new-img/IconSchedule.svg?react'));
export { default as VideoIconFilled } from 'assets/images/new-img/VideoIconFilled.svg?react';
export { default as IconEmptyChat } from 'assets/images/new-img/Icon-empty-chat.svg?react';
export { default as IconAppIcon } from 'assets/images/new-img/IconAppIcon.svg?react';
export { default as IconNewWindow } from 'assets/images/new-img/IconNewWindow.svg?react';
export { default as ChainLinkIcon } from 'assets/images/new-img/chain-link-icon.svg?react';
export { default as IconLink } from 'assets/images/new-img/chain-link-icon.svg?react';
export { default as IconNext } from 'assets/images/new-img/IconNext.svg?react';
export { default as IconSelectTick } from 'assets/images/new-img/IconSelectTick.svg?react';
export { default as IconPin } from 'assets/images/new-img/IconPin.svg?react';
export { default as IconUnpin } from 'assets/images/new-img/IconUnpin.svg?react';
export { default as IconPinnedFilled } from 'assets/images/new-img/IconPinnedFilled.svg?react';
export { default as IconArrowLeft } from 'assets/images/IconArrowLeft.svg?react';
export { default as IconAddInvite } from 'assets/images/IconAddInvite.svg?react';
export { default as IconPeople } from 'assets/images/IconPeople.svg?react';
export { default as IconAppCreategroup } from 'assets/images/new-img/IconAppCreategroup.svg?react';
export { default as IconUsers } from 'assets/images/IconUsers.svg?react';

// chat icons
export { default as IconEmptyPlaceholderChat } from 'assets/images/IconEmptyPlaceholderChat.svg?react';
